import dayjs from "../../../utility/dayjs";
import Utils from "../../../utility";

const initialState = {
  warehouseToWarehouse: [],
  order: "DESC",
  // sortField:"warehouseNickname",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  warehouseToWarehouseForExport: [],
  fromDate: dayjs(),
  toDate: dayjs(),
};
export const warehouseToWarehouseReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.WAREHOUSE_TO_WAREHOUSE}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
